import {
  checkListRecurringApproved,
  SuccessResponse,
  ValidationRecurringResponse,
} from '@back-office/http';
import { FlowReturn } from 'mobx-state-tree/dist/core/flow';
import { ResponseMessage } from '../../constants';
import { handleErrorVoidRefund, Self } from '../common';

function* approvedRecurringFileCheckListRequest(
  self: Self,
  data: {
    onboardBatchID: string[];
  }
): Generator<Promise<FlowReturn<SuccessResponse>>> {
  self.isLoading = true;
  try {
    const response = yield checkListRecurringApproved(data);
    const { onboardBatch, Summary } = (response as ValidationRecurringResponse)
      .data;
    if (Summary.total > 0) {
      return { onboardBatch, Summary };
    }
    // if (response?.status === 200) {
    //   return response.data;
    // }
    // if (status.code === STATUS_CODE_SUCCESS) {
    //   return Promise.resolve(status.code);
    // }
    // if (status.code === STATUS_CODE_NOT_AUTHORIZED) {
    //   handleNotAuthorized(self, response as SuccessResponse);
    //   return Promise.reject(status.code);
    // }
    handleErrorVoidRefund(self);
    return Promise.reject(new Error(ResponseMessage.Error));
  } catch (e) {
    return Promise.resolve('Internal server error.');
  } finally {
    self.isLoading = false;
  }
}

export default approvedRecurringFileCheckListRequest;
